module.exports = __webpack_public_path__ + "static/img/outpatienta.1eb0dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outpatienta.png
// module id = NMwQ
// module chunks = 1